export default {
    PAYMENT_METHODS_PAGE: 'payment-methods',
    METHOD_RESULT_PAGE: 'method-result',
    INVOICES_PAGE: 'invoices',
} as const;
